














































































import { Component, Vue, Watch } from 'vue-property-decorator'
import SuporteTipoAcomodacaoStore from '@/components/Suporte/Store/SuporteTipoAcomodacaoStore'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'

@Component
export default class ComponentModalSuporteTipoAcomodacao extends Vue {
  loadSaveOrUpdateTipoAcomodacao: boolean = false

  get getSuporteTipoAcomodacaoStore() {
    return getModule(SuporteTipoAcomodacaoStore, this.$store)
  }

  get loadingSaveOrUpdateTipoAcomodacao() {
    return this.loadSaveOrUpdateTipoAcomodacao
  }

  set loadingSaveOrUpdateTipoAcomodacao(value: boolean) {
    this.loadSaveOrUpdateTipoAcomodacao = value
  }

  get showModalTipoAcomodacao() {
    return this.getSuporteTipoAcomodacaoStore.modal.tipoAcomodacao
  }

  set showModalTipoAcomodacao(value: boolean) {
    this.getSuporteTipoAcomodacaoStore.setModal({ name: 'tipoAcomodacao', value })
  }

  get tipoAcomodacao() {
    return this.getSuporteTipoAcomodacaoStore.tipoAcomodacao
  }

  $refs!: {
    formTipoAcomodacao: any
  }

  formTipoAcomodacaoRules: any = {
    valid: true,
    hisId: [],
    descricao: [(v: any) => !!v || 'Campo obrigatório.'],
    status: [(v: any) => !!v || 'Campo obrigatório.'],
  }

  async saveOrUpdateTipoAcomodacao() {
    this.loadingSaveOrUpdateTipoAcomodacao = true

    if (this.$refs.formTipoAcomodacao.validate()) {
      const { mode } = this.getSuporteTipoAcomodacaoStore

      const response = await this.getSuporteTipoAcomodacaoStore.upsertTipoAcomodacao()

      if (response.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Tipo de acomodação ${mode === 'CREATE' ? 'criada' : 'alterada'} com sucesso! ${String.fromCodePoint(0x1F642)}`,
          icon: 'done',
          color: '#2E7D32',
        })

        await this.getSuporteTipoAcomodacaoStore.getAllTipoAcomodacaoByHospitalId(this.getSuporteTipoAcomodacaoStore.hospitalId)
        this.showModalTipoAcomodacao = false
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao ${mode === 'CREATE' ? 'criar' : 'alterar'} o tipo de acomodação ${String.fromCodePoint(0x1F615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingSaveOrUpdateTipoAcomodacao = false
  }

  @Watch('showModalTipoAcomodacao')
  onChangeshowModalTipoAcomodacao(value: boolean) {
    if (!value) {
      this.getSuporteTipoAcomodacaoStore.clearTipoAcomodacao()
      this.getSuporteTipoAcomodacaoStore.setMode('CREATE')
      this.$refs.formTipoAcomodacao.resetValidation()
    }
  }
}
